import { useCallback, useEffect, useMemo, useState } from "react";
import { getInsightsApi } from "../../utils/get-insights";
import {
  ConsumptionTrendEnum,
  InsightsConsumption,
  UseInsightsConsumptionProps,
} from "./insights-consumption.types";
import { logError } from "@/_old/utils/errors";

export function useInsightsConsumption({
  companyId,
  startDate,
  endDate,
}: UseInsightsConsumptionProps) {
  const [data, setData] = useState<InsightsConsumption | undefined>();

  const [isLoading, setIsLoading] = useState(false);

  const status = data?.status;

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const response = await getInsightsApi(
        "/insights-consumption",
        startDate,
        endDate,
        undefined,
        companyId.toString(),
      );

      setData(response);
    } catch (error) {
      logError(error, {
        componentStack: "useInsightsConsumption",
      });
    } finally {
      setIsLoading(false);
    }
  }, [companyId, startDate, endDate]);

  useEffect(() => {
    fetchData();

    return () => {
      setData(undefined);
    };
  }, [fetchData]);

  const type = useMemo((): "danger" | "default" | "good" | "warning" => {
    if (status === ConsumptionTrendEnum.Stable) {
      return "good";
    }

    if (status === ConsumptionTrendEnum.Decreasing) {
      return "warning";
    }

    if (status === ConsumptionTrendEnum.Increasing) {
      return "danger";
    }

    return "default";
  }, [status]);

  return { data, isLoading, type };
}
